import type { DeepPartial } from '@luna/utils-ts';

import type { Search } from '../../types/Search';

export const searchHRFeatureConfig: DeepPartial<Search> = {
    countryProductId: 'SECURITIES',
    displayIssuerForShares: true,
    extraGroupTypeKeys: ['PREMIUM_DEPOSIT'],
    showExperienceProfileMissingTooltip: true,
};
